<template>
  <div class="row">
    <div
      v-if="loading"
      class="col-12">
      <div class="col text-center mt-5">
        <i class="fa fa-spinner fa-spin fa-2x fa-fw"/>
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div
      v-if="!loading"
      class="col-12">
      <div class="row">
        <card-default>
          <div
            slot="title"
            class="card-heading row">
            <div class="col h4">
              <span v-if="edit">
                {{ newUser.username }}
              </span>
              <span v-else>
                New user
              </span>
            </div>
            <div class="col float-right">
              <auth-button
                :permission="edit ? 'user-update' : 'user-create'"
                class="btn btn-primary btn-micro float-right"
                @click="proxySave"
              >
                Save
              </auth-button>
            </div>
          </div>
          <div
            slot="body"
            class="card-text">
            <div class="row">
              <field-input
                v-model="newUser.username"
                name="username"
                label="Username"
                class="col"
              />
              <field-input
                v-model="newUser.email"
                name="email"
                label="Email"
                class="col"
              />
            </div>
          </div>
        </card-default>
      </div>
      <div
        v-if="edit"
        class="row"
      >
        <card-default>
          <div
            slot="title"
            class="card-heading row">
            <div class="col h4">
              <span>
                Change password
              </span>
            </div>
            <div class="col float-right">
              <auth-button
                permission="change-password-change-user-password"
                class="btn btn-primary btn-micro float-right"
                @click="changeUserPassword({ newPassword, newPasswordRepeat })"
              >
                Change
              </auth-button>
            </div>
          </div>
          <div
            slot="body"
            class="card-text">
            <div class="row">
              <field-input
                v-model="newPassword"
                type="password"
                name="password"
                label="New password"
                class="col"
              />
              <field-input
                v-model="newPasswordRepeat"
                type="password"
                name="password_repeat"
                label="Repeat new password"
                class="col"
              />
            </div>
          </div>
        </card-default>
      </div>
      <div class="row">
        <card-default v-if="edit">
          <div
            slot="title"
            class="card-heading row">
            <div class="col h4">
              Roles
            </div>
            <div class="col float-right">
              <auth-button
                class="btn btn-primary btn-micro float-right"
                permission="user-assign-role"
                @click="saveRoles"
              >
                Save
              </auth-button>
            </div>
          </div>
          <div
            slot="body"
            class="card-text">
            <div class="row">
              <field-select2
                v-model="selectedRoles"
                :options="roles"
                :on-change="setRoles"
                name="roles"
                label="Roles"
                class="col"
                multiple
                searchable
                option-label="name"
              />
            </div>
          </div>
        </card-default>
      </div>
      <div class="row">
        <card-default v-if="edit">
          <div
            slot="title"
            class="card-heading row">
            <div class="col h4">
              Sites
            </div>
            <div class="col float-right">
              <auth-button
                class="btn btn-primary btn-micro float-right"
                permission="user-assign-role"
                @click="saveSites"
              >
                Save
              </auth-button>
            </div>
          </div>
          <div
            slot="body"
            class="card-text">
            <div class="row">
              <field-select2
                v-model="selectedSites"
                :options="sites"
                :on-change="setSites"
                name="sites"
                label="Sites"
                class="col"
                multiple
                searchable
                option-label="name"
              />
            </div>
          </div>
        </card-default>
      </div>
      <div class="row">
        <card-default v-if="edit">
          <div
            slot="title"
            class="card-heading row">
            <div class="col h4">
              Delete
            </div>
            <div class="col float-right">
              <auth-button
                class="btn btn-danger btn-micro float-right"
                permission="user-delete"
                @click="confirmRemove"
              >
                Delete
              </auth-button>
            </div>
          </div>
        </card-default>
      </div>
    </div>
  </div>
</template>

<script>
import CardDefault from '@/components/CardDefault'
import FieldInput from '@/components/form/FieldInput'
import FieldSelect2 from '@/components/form/FieldSelect2'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'UsersCreate',
  components: {
    FieldInput,
    CardDefault,
    FieldSelect2
  },
  data () {
    return {
      loading: false,
      edit: false,
      newPassword: '',
      newPasswordRepeat: ''
    }
  },
  computed: {
    ...mapGetters('user', [
      'newUser',
      'selectedRoles',
      'selectedSites'
    ]),
    ...mapGetters({
      roles: 'role/roles',
      sites: 'site/allSites'
    })
  },
  created () {
    this.getAllRoles()
    this.getAllSites()
    this.clearNew()
    this.edit = this.$route.params.id
    if (this.edit) {
      this.loading = true
      this.getById(this.edit).then(() => {
        this.setNew(this.edit)
        this.loading = false
        this.getRoles()
        this.getSites()
      })
    }
  },
  methods: {
    ...mapMutations('user', {
      setNew: 'SET_NEW',
      clearNew: 'CLEAR_NEW',
      setRoles: 'SET_ROLES',
      setSites: 'SET_SITES'
    }),
    ...mapActions('user', [
      'create',
      'save',
      'getById',
      'getRoles',
      'saveRoles',
      'getSites',
      'saveSites',
      'remove',
      'changeUserPassword'
    ]),
    ...mapActions({
      getAllRoles: 'role/get',
      getAllSites: 'site/getAllSites'
    }),
    proxySave () {
      if (this.edit) {
        this.save()
      } else {
        this.create()
          .then(({ data }) => this.$router.push('/users/' + data.id))
      }
    },
    confirmRemove () {
      if (confirm('Are you sure you want to delete this user?')) {
        this.remove().then(() => {
          this.$router.push('.')
        })
      }
    }
  }
}
</script>
